export default __webpack_public_path__ + "static/media/782.a1f0d7cb.png";